import CookieStore from 'ember-simple-auth/session-stores/cookie';
import { EMBER_SIMPLE_AUTH_SESSION_COOKIE, AUTH_COOKIE_EXPIRES_IN_SECONDS } from 'cio/utils/auth-cookies';

// using default AdaptiveStore causes "QuotaExceededError" for some users: https://sentry.io/customerio/ui/issues/876507669/
// it's likely related to specific user's browser settings, reducing limits of local storage available
// no matter the cause: it's a real error affecting customers that we have no control over, which is good rationale for using safer cookie store instead
export default CookieStore.extend({
  cookieExpirationTime: AUTH_COOKIE_EXPIRES_IN_SECONDS,

  cookieName: EMBER_SIMPLE_AUTH_SESSION_COOKIE, // value same as default, but setting explicitly to avoid getting out of sync with "auth-cookies" util module

  sameSite: 'Strict',
});
